import { index } from './utils';
import translations from '../app/translations/it';

index(translations);
